console.log("custom theme")

function main() {
    function addPopupAriaLive() { 
        const popupInner = document.querySelector('.purchase-confirmation-popup__inner');
        if (!popupInner) return; 

        // Keep aria-live region exposed for screen readers
        popupInner.style.visibility = 'visible';
        popupInner.setAttribute('role', 'status');
        popupInner.setAttribute('aria-live', 'polite');
    }

    function initPurchaseConfirmationFocus() {
        const popup = document.querySelector('.purchase-confirmation-popup');
        if (!popup) return;

        let hasKeyboardFocus = false;
        let customCloseTimeout = null;
        let userClosedExplicitly = false;

        function moveFocus() {
            const viewCart = popup.querySelector('.purchase-confirmation-popup__view-cart');
            const checkout = popup.querySelector('.purchase-confirmation-popup__submit');
            const target = viewCart || checkout;
            if (target && typeof target.focus === 'function') {
                // Defer to ensure buttons exist after inner HTML is injected
                setTimeout(function () {
                    target.focus();
                }, 0);
            }
        }

        function scheduleCustomClose() {
            if (customCloseTimeout) {
                clearTimeout(customCloseTimeout);
            }
            // Close 1s after keyboard focus leaves the popup
            customCloseTimeout = setTimeout(function () {
                if (hasKeyboardFocus) return;
                userClosedExplicitly = true;
                popup.classList.remove('active');
                popup.setAttribute('aria-hidden', 'true');
            }, 1000);
        }

        // Track keyboard focus inside the popup
        popup.addEventListener('focusin', function () {
            hasKeyboardFocus = true;
            userClosedExplicitly = false;
            if (customCloseTimeout) {
                clearTimeout(customCloseTimeout);
                customCloseTimeout = null;
            }
        });

        popup.addEventListener('focusout', function (e) {
            const next = e.relatedTarget;
            if (!next || !popup.contains(next)) {
                hasKeyboardFocus = false;
                if (popup.classList.contains('active')) {
                    scheduleCustomClose();
                }
            }
        });

        // Respect explicit close button (both mouse and keyboard)
        popup.addEventListener('click', function (e) {
            const closeBtn = e.target.closest('[data-confirmation-close]');
            if (!closeBtn || !popup.contains(closeBtn)) return;
            // Mark as explicitly closed so observer does not immediately re-open it
            userClosedExplicitly = true;
            hasKeyboardFocus = false;
            if (customCloseTimeout) {
                clearTimeout(customCloseTimeout);
                customCloseTimeout = null;
            }
        }, true);

        // If popup is already active when this runs
        if (popup.classList.contains('active')) {
            moveFocus();
        }

        // Watch for the popup becoming active or inactive
        const observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (m) {
                if (m.type === 'attributes' && m.attributeName === 'class') {
                    const isActive = popup.classList.contains('active');
                    if (isActive) {
                        // Popup just opened (or re-opened)
                        userClosedExplicitly = false;
                        moveFocus();
                        // Theme will auto-close after 5s; if user is interacting with keyboard, re-open
                        if (hasKeyboardFocus) {
                            // Ensure it stays visible while focused
                            popup.setAttribute('aria-hidden', 'false');
                        }
                    } else {
                        // If theme closed it while we still have keyboard focus, immediately re-open
                        if (hasKeyboardFocus && !userClosedExplicitly) {
                            popup.classList.add('active');
                            popup.setAttribute('aria-hidden', 'false');
                        }
                    }
                }
            });
        });

        observer.observe(popup, { attributes: true, attributeFilter: ['class'] });
    }

    addPopupAriaLive();
    initPurchaseConfirmationFocus();


    // Header nav: theme only opens menus on focus/mouseover, not on click or Enter/Space.
    // So when user activates the chevron (click or keyboard), re-trigger focus so the theme opens the menu.
    function initHeaderNavActivation() {
        const nav = document.querySelector('.header__links-primary');
        if (!nav) return;
        const header = document.querySelector('[data-section-type="header"]');

        function isTrigger(el) {
            return el && (el.hasAttribute('data-dropdown-trigger') || el.hasAttribute('data-meganav-trigger'));
        }

        function triggerMenuOpen(trigger) {
            if (!isTrigger(trigger)) return;
            const li = trigger.closest('li');
            if (!li) return;
            const submenu = li.querySelector('[data-submenu]');
            const menuId = trigger.getAttribute('aria-controls');
            const meganav = menuId ? document.getElementById(menuId) : null;
            // Blur then refocus so the theme's focus handler runs and toggles the menu (theme opens on focus, not click)
            trigger.blur();
            setTimeout(function () {
                trigger.focus();
                // After theme opens the menu, move focus into the first link (dropdown or meganav)
                setTimeout(function () {
                    const panel = submenu || meganav;
                    if (!panel || panel.getAttribute('aria-hidden') === 'true') return;
                    const firstLink = panel.querySelector('a[href]');
                    if (firstLink) firstLink.focus();
                }, 80);
            }, 0);
        }

        // When tabbing to the top-level link text (e.g. “Shop K-Beauty”), keep the submenu collapsed by default.
        // Theme auto-opens on focus; we immediately re-collapse so it only stays open when activated via chevron or mouse hover.
        nav.addEventListener('focusin', function (e) {
            const link = e.target.closest('.navigation__submenu-trigger');
            if (!link) return;
            const li = link.closest('li[data-submenu-parent]');
            if (!li || !nav.contains(li)) return;

            const submenu = li.querySelector('[data-submenu]');
            const menuId = link.getAttribute('aria-controls');
            const meganav = menuId ? document.getElementById(menuId) : null;
            const panel = submenu || meganav;
            if (!panel) return;

            // Re-collapse panel that the theme may have auto-opened on focus
            panel.setAttribute('aria-hidden', 'true');
            panel.classList.remove('active');

            const triggers = li.querySelectorAll('[data-link], [data-parent]');
            triggers.forEach(function (t) {
                t.setAttribute('aria-expanded', 'false');
            });

            if (header) {
                header.classList.remove('dropdown-active');
            }
        });

        nav.addEventListener('click', function (e) {
            const trigger = e.target.closest('button[data-dropdown-trigger], button[data-meganav-trigger], a[data-dropdown-trigger], a[data-meganav-trigger]');
            if (!trigger) return;
            // For buttons, always treat as menu trigger.
            // For links, also treat as trigger when they control a submenu (data-dropdown-trigger / data-meganav-trigger),
            // so screen readers (which often activate links via "click") can open the menu instead of navigating.
            const isLink = trigger.tagName === 'A';
            const hasSubmenuRole = trigger.hasAttribute('data-dropdown-trigger') || trigger.hasAttribute('data-meganav-trigger');
            if (isLink && !hasSubmenuRole) return;
            e.preventDefault();
            e.stopPropagation();
            triggerMenuOpen(trigger);
        }, true);

        nav.addEventListener('keydown', function (e) {
            if (e.key !== 'Enter' && e.key !== ' ') return;
            const trigger = e.target.closest('button[data-dropdown-trigger], button[data-meganav-trigger], a[data-dropdown-trigger], a[data-meganav-trigger]');
            if (!trigger) return;
            e.preventDefault();
            triggerMenuOpen(trigger);
        }, true);
    }

    // Product video (desktop + mobile): add a Plyr-style overlay play button for plain <video> elements.
    // Run on load and after a short delay so mobile gallery panels (which may render with the page) get the icon on first load.
    function initDesktopPlyrOverlay() {
        const selector =
          '.product__media-item[data-media-type="video"] .media[data-media-type="video"]:not(.plyr-initialized), ' +
          '.mobile-thumbs-gallery__panel[data-media-type="video"] .media[data-media-type="video"]:not(.plyr-initialized)';
        const mediaItems = document.querySelectorAll(selector);
        mediaItems.forEach(function (media) {
            if (media.querySelector('.plyr')) return; // theme already enhanced
            const video = media.querySelector('video');
            if (!video) return;

            media.classList.add('plyr-initialized');

            // Create Plyr-style wrapper
            const wrapper = document.createElement('div');
            // Match Shopify/Plyr desktop markup so existing CSS shows the overlaid play icon
            wrapper.className = 'plyr plyr--full-ui plyr--video plyr--html5 plyr--stopped plyr--hide-controls';

            const videoWrapper = document.createElement('div');
            videoWrapper.className = 'plyr__video-wrapper';

            // Move video into wrapper
            const parent = video.parentNode;
            parent.insertBefore(wrapper, video);
            videoWrapper.appendChild(video);
            wrapper.appendChild(videoWrapper);

            // Overlaid play/pause control (matches Plyr class names so existing CSS applies)
            const overlayButton = document.createElement('button');
            overlayButton.type = 'button';
            overlayButton.className = 'plyr__control plyr__control--overlaid';
            overlayButton.setAttribute('data-plyr', 'play');
            overlayButton.setAttribute('aria-label', 'Play');
            overlayButton.innerHTML =
              '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" ' +
                'style="width: 56px; height: 56px; fill: currentColor;">' +
                  '<polygon points="8,5 19,12 8,19"></polygon>' +
              '</svg>' +
              '<span class="plyr__sr-only">Play</span>';

            wrapper.appendChild(overlayButton);

            function togglePlay() {
                if (video.paused) {
                    video.play();
                    wrapper.classList.remove('plyr--stopped');
                    wrapper.classList.add('plyr--playing');
                    overlayButton.setAttribute('aria-label', 'Pause');
                } else {
                    video.pause();
                    wrapper.classList.remove('plyr--playing');
                    wrapper.classList.add('plyr--stopped');
                    overlayButton.setAttribute('aria-label', 'Play');
                }
            }

            overlayButton.addEventListener('click', togglePlay);
            video.addEventListener('click', togglePlay);
        });
    }

    initHeaderNavActivation();
    initDesktopPlyrOverlay();
    // Re-run after a short delay so mobile thumbs gallery video gets the overlay on first load (no refresh needed)
    setTimeout(initDesktopPlyrOverlay, 400);

    // Okendo a11y fix: visible live alerts should not be hidden from assistive tech.
    // Hidden-Visible-Content (.oke-alert--top / --bottom, live regions): strip aria-hidden.
    function fixOkendoHiddenAlerts() {
        var alertInBar = ".oke-w-reviews-alerts > .oke-alert";

        function isOkendoLiveAlert(el) {
            if (!(el instanceof HTMLElement)) return false;
            if (!el.matches || !el.matches(alertInBar)) return false;
            if (el.getAttribute("aria-hidden") !== "true") return false;
            var role = el.getAttribute("role");
            var live = el.getAttribute("aria-live");
            return (
                role === "alert" ||
                live === "assertive" ||
                live === "polite" ||
                el.classList.contains("oke-alert--top") ||
                el.classList.contains("oke-alert--bottom")
            );
        }

        function unhideAlerts(root) {
            var scope = root && root.querySelectorAll ? root : document;
            var alerts = scope.querySelectorAll(alertInBar + '[aria-hidden="true"]');
            alerts.forEach(function (el) {
                if (isOkendoLiveAlert(el)) {
                    el.removeAttribute("aria-hidden");
                }
            });
        }

        unhideAlerts(document);

        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (m) {
                if (m.type === "attributes" && m.attributeName === "aria-hidden") {
                    if (isOkendoLiveAlert(m.target)) {
                        m.target.removeAttribute("aria-hidden");
                    }
                }
                m.addedNodes.forEach(function (node) {
                    if (!(node instanceof HTMLElement)) return;

                    if (isOkendoLiveAlert(node)) {
                        node.removeAttribute("aria-hidden");
                    }

                    unhideAlerts(node);
                });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ["aria-hidden"]
        });
    }

    fixOkendoHiddenAlerts();

    // Okendo a11y fix: if tooltip is visually hidden, hide it from assistive tech too.
    function fixOkendoHiddenTooltips() {
        var tooltipSelector = '.oke-tooltip > [id^="tooltip-"]';

        function syncTooltipA11y(root) {
            var scope = root && root.querySelectorAll ? root : document;
            var tooltips = scope.querySelectorAll(tooltipSelector);

            tooltips.forEach(function (el) {
                var style = window.getComputedStyle(el);
                var isHidden =
                    style.opacity === "0" ||
                    style.visibility === "hidden" ||
                    style.display === "none" ||
                    el.offsetParent === null ||
                    el.hasAttribute("hidden");

                if (isHidden) {
                    el.setAttribute("aria-hidden", "true");
                } else {
                    el.removeAttribute("aria-hidden");
                }
            });
        }

        // Initial pass
        syncTooltipA11y(document);

        // Keep in sync for async widget updates and style/class changes
        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (m) {
                if (m.type === "attributes") {
                    syncTooltipA11y(m.target);
                }
                m.addedNodes.forEach(function (node) {
                    if (node instanceof HTMLElement) {
                        syncTooltipA11y(node);
                    }
                });
            });
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ["style", "class", "hidden", "aria-hidden"]
        });
    }

    fixOkendoHiddenTooltips();

    // Okendo a11y fix (Fake-Hidden-Content): summary star placeholders in carousels / product cards
    // can be visually empty or hidden but still exposed to AT — add aria-hidden="true" until real content shows.
    function fixOkendoFakeHiddenSrStars() {
        var selector = "[data-oke-reviews-product-id] .oke-sr-stars, .okeReviews.oke-sr .oke-sr-stars";

        function isVisuallyHidden(el) {
            var style = window.getComputedStyle(el);
            return (
                style.opacity === "0" ||
                style.visibility === "hidden" ||
                style.display === "none" ||
                (el.offsetParent === null && style.position !== "fixed")
            );
        }

        function isLeafEmptyDiv(el) {
            return (
                el &&
                el.tagName === "DIV" &&
                el.children.length === 0 &&
                !el.textContent.trim()
            );
        }

        // Deepest divs first so nested <div><div></div></div> placeholders are all covered (AccessFlow path: div > .oke-sr-stars)
        function syncDescendantPlaceholdersUnderStars(starsEl) {
            var divs = starsEl.querySelectorAll("div");
            var list = Array.prototype.slice.call(divs).reverse();
            list.forEach(function (d) {
                if (isVisuallyHidden(d) || isLeafEmptyDiv(d)) {
                    d.setAttribute("aria-hidden", "true");
                } else {
                    d.removeAttribute("aria-hidden");
                }
            });
        }

        // Empty sibling divs next to the stars node inside Okendo’s wrapper
        function syncSiblingPlaceholderDivs(starsEl) {
            var parent = starsEl.parentElement;
            if (!parent) return;
            Array.prototype.forEach.call(parent.children, function (child) {
                if (child === starsEl || child.tagName !== "DIV") return;
                if (isVisuallyHidden(child) || isLeafEmptyDiv(child)) {
                    child.setAttribute("aria-hidden", "true");
                } else {
                    child.removeAttribute("aria-hidden");
                }
            });
        }

        // Always scan document: mutations often fire on inner nodes where querySelectorAll(selector) would miss .oke-sr-stars
        function syncSrStarsA11y() {
            var nodes = document.querySelectorAll(selector);

            nodes.forEach(function (el) {
                var visuallyHidden = isVisuallyHidden(el);

                var emptyPlaceholder =
                    el.children.length === 0 && !el.textContent.trim();

                if (visuallyHidden || emptyPlaceholder) {
                    el.setAttribute("aria-hidden", "true");
                } else {
                    el.removeAttribute("aria-hidden");
                    syncDescendantPlaceholdersUnderStars(el);
                    syncSiblingPlaceholderDivs(el);
                }
            });
        }

        var debounceId = null;

        function scheduleSyncSrStars() {
            if (debounceId) {
                clearTimeout(debounceId);
            }
            debounceId = setTimeout(function () {
                debounceId = null;
                syncSrStarsA11y();
            }, 50);
        }

        syncSrStarsA11y();

        window.addEventListener("load", scheduleSyncSrStars);

        [100, 400, 1200, 2800].forEach(function (ms) {
            setTimeout(scheduleSyncSrStars, ms);
        });

        var observer = new MutationObserver(function () {
            scheduleSyncSrStars();
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ["style", "class", "hidden", "aria-hidden"]
        });
    }

    fixOkendoFakeHiddenSrStars();

    // Quick-view for buttons outside complete-the-look/shoppable (e.g. product pairing).
    // We fetch the quick-view HTML, inject it, open the modal, and wire variants/quantity/add-to-cart (no theme.js edits).
    function initProductPairingQuickView() {
        document.body.addEventListener("click", function (e) {
            var btn = e.target.closest('[data-quick-shop-trigger="quick-view"]');
            if (!btn || !btn.dataset.productUrl) return;
            if (btn.closest("[data-section-type=\"complete-the-look\"]") || btn.closest("[data-section-type=\"shoppable\"]") || btn.closest("[data-featured-products]")) return;

            e.preventDefault();
            e.stopPropagation();

            var productUrl = btn.dataset.productUrl;
            var xhrUrl = productUrl + (productUrl.indexOf("?") !== -1 ? "&" : "?") + "view=quick-view";
            var modal = document.querySelector("[data-quick-view-modal]");
            var content = modal ? modal.querySelector(".quick-view-modal__content") : null;
            if (!modal || !content) return;

            fetch(xhrUrl)
                .then(function (res) { return res.text(); })
                .then(function (html) {
                    var parser = new DOMParser();
                    var doc = parser.parseFromString(html, "text/html");
                    var productEl = doc.querySelector("[data-is-quick-view]");
                    if (!productEl) return;

                    content.classList.remove("empty");
                    content.innerHTML = "";
                    content.appendChild(productEl);

                    initQuickViewForm(productEl);

                    modal.classList.add("is-fixed");
                    modal.setAttribute("aria-hidden", "false");
                    setTimeout(function () {
                        modal.classList.add("active");
                        setTimeout(function () {
                            modal.classList.add("is-visible");
                            document.body.setAttribute("data-fluorescent-overlay-open", "true");
                        }, 50);
                    }, 50);
                })
                .catch(function () {});
        }, true);
    }

    // Quick-add for single-variant products outside complete-the-look/shoppable (e.g. product pairing).
    // Mirrors theme.js complete-the-look quick-add behavior but uses AJAX /cart/add.js directly.
    function initProductPairingQuickAdd() {
        document.body.addEventListener("click", function (e) {
            var btn = e.target.closest('[data-quick-shop-trigger="quick-add"]');
            if (!btn || !btn.dataset.productId) return;
            if (btn.closest("[data-section-type=\"complete-the-look\"]") || btn.closest("[data-section-type=\"shoppable\"]") || btn.closest("[data-featured-products]")) return;

            e.preventDefault();
            e.stopPropagation();

            if (btn.disabled) return;
            btn.disabled = true;
            btn.classList.add("loading");

            var body = new FormData();
            body.append("id", btn.dataset.productId);
            body.append("quantity", "1");

            var addUrl = (window.theme && window.theme.routes && window.theme.routes.cart && window.theme.routes.cart.add)
                ? (window.theme.routes.cart.add + (window.theme.routes.cart.add.indexOf(".js") !== -1 ? "" : ".js"))
                : "/cart/add.js";

            fetch(addUrl, {
                method: "POST",
                body: body
            })
                .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
                .then(function (result) {
                    btn.disabled = false;
                    btn.classList.remove("loading");
                    if (!result.ok) return;

                    var data = result.data || {};
                    var purchaseConfirmation = document.querySelector("[data-purchase-confirmation-popup]");
                    var quickCart = document.querySelector(".quick-cart");

                    // Always notify global cart listeners
                    document.dispatchEvent(new CustomEvent("cart:updated", { detail: data }));

                    // Mirror theme.js ProductItem / Product handlers:
                    // 1) If confirmation popup is enabled, load the purchase-confirmation-popup-item section
                    //    and reveal the newly added line item inside it.
                    if (purchaseConfirmation) {
                        var containerInner = purchaseConfirmation.querySelector(".purchase-confirmation-popup__inner");
                        if (containerInner) {
                            var cartBase = (window.theme && window.theme.routes && window.theme.routes.cart && window.theme.routes.cart.base)
                                ? window.theme.routes.cart.base
                                : "/cart";
                            var requestUrl = cartBase + "/?section_id=purchase-confirmation-popup-item";
                            var addedKey = data && data.key ? data.key : null;

                            fetch(requestUrl, { method: "GET" })
                                .then(function (res) { return res.text(); })
                                .then(function (html) {
                                    var container = document.createElement("div");
                                    container.innerHTML = html;
                                    containerInner.innerHTML = "";
                                    containerInner.appendChild(container);

                                    // Initialize the free shipping bar inside the confirmation popup,
                                    // mirroring the theme's freeShippingBar behavior well enough for messaging.
                                    var fsBar = purchaseConfirmation.querySelector("[data-free-shipping-bar]");
                                    if (fsBar) {
                                        var threshold = parseInt(fsBar.dataset.threshold || "0", 10);
                                        var cartTotal = parseInt(fsBar.dataset.cartTotal || "0", 10); // already in cents
                                        var rate = (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1;
                                        threshold = Math.round(threshold * rate);
                                        var thresholdInCents = threshold * 100;
                                        var msgEl = fsBar.querySelector(".free-shipping-bar__message");
                                        if (msgEl) {
                                            if (cartTotal >= thresholdInCents) {
                                                msgEl.innerHTML = fsBar.dataset.freeShippingSuccessMessage || "";
                                            } else {
                                                var remainder = Math.abs(cartTotal - thresholdInCents);
                                                var formattedRemaining = "";
                                                if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
                                                    var moneyFormat = (window.theme && window.theme.moneyFormat) || window.Shopify.money_format;
                                                    formattedRemaining = window.Shopify.formatMoney(remainder, moneyFormat);
                                                } else {
                                                    formattedRemaining = (remainder / 100).toLocaleString(undefined, { style: "currency", currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "USD" });
                                                }
                                                var pendingTemplate = fsBar.dataset.freeShippingPendingMessage || "";
                                                msgEl.innerHTML = pendingTemplate.replace("{{ remaining_amount }}", '<span class="fs-body-bold">' + formattedRemaining + "</span>");
                                            }
                                        }
                                        var progressBar = fsBar.querySelector(".free-shipping-bar__bar-progress");
                                        if (progressBar) {
                                            var progress = cartTotal < thresholdInCents ? (cartTotal / threshold) : 100;
                                            progressBar.style.setProperty("--progress-width", progress + "%");
                                        }
                                        fsBar.classList.add("free-shipping-bar--loaded");
                                    }

                                    if (addedKey) {
                                        var addedProduct = purchaseConfirmation.querySelector('[data-product-key="' + addedKey + '"]');
                                        if (addedProduct) {
                                            addedProduct.classList.remove("hidden");
                                        }
                                    }

                                    purchaseConfirmation.classList.add("active");

                                    // Auto-close after 5s, matching theme behavior closely enough.
                                    setTimeout(function () {
                                        purchaseConfirmation.classList.remove("active");
                                    }, 5000);
                                })
                                .catch(function () {});
                            return;
                        }
                    }

                    // 2) If no confirmation popup but quick cart exists, open quick cart instead.
                    if (quickCart) {
                        document.dispatchEvent(new CustomEvent("quick-cart:updated"));
                        setTimeout(function () {
                            document.dispatchEvent(new CustomEvent("quick-cart:open"));
                        }, 300);
                    }
                })
                .catch(function () {
                    btn.disabled = false;
                    btn.classList.remove("loading");
                });
        }, true);
    }

    function initQuickViewForm(container) {
        var variantJsonScript = container.querySelector("script[data-variant-json]");
        var variants = [];
        if (variantJsonScript && variantJsonScript.textContent) {
            try {
                variants = JSON.parse(variantJsonScript.textContent.trim());
            } catch (err) {}
        }

        var form = container.querySelector("[data-product-form]");
        if (!form) return;

        var variantSelect = container.querySelector("[data-variant-select], select[name=\"id\"]");
        var formQuantityInput = form.querySelector("input[name=\"quantity\"]");

        // Variant chips: on click set select to matching variant id
        container.querySelectorAll(".product__chip[data-option-value], .dynamic-variant-button[data-option-value]").forEach(function (chip) {
            chip.addEventListener("click", function () {
                var value = chip.getAttribute("data-option-value");
                var optionKey = chip.closest("[data-product-option]");
                var index = optionKey ? (optionKey.getAttribute("data-index") || "option1") : "option1";
                var variant = variants.find(function (v) {
                    return (v.option1 && v.option1 === value) || (v.option2 && v.option2 === value) || (v.option3 && v.option3 === value);
                });
                if (variant && variantSelect) {
                    variantSelect.value = String(variant.id);
                    variantSelect.dispatchEvent(new Event("change", { bubbles: true }));
                }
                container.querySelectorAll(".product__chip.selected, .dynamic-variant-button.selected").forEach(function (c) { c.classList.remove("selected"); });
                chip.classList.add("selected");
            });
        });

        // Quantity: sync block quantity with form quantity and wire +/- buttons
        var blockQtyInput = container.querySelector(".quantity-input__input, input[data-quantity-input]");
        var subtractBtn = container.querySelector("[data-subtract-quantity], .product__quantity-subtract-item");
        var addBtn = container.querySelector("[data-add-quantity], .product__quantity-add-item");

        function setQuantity(val) {
            var n = parseInt(val, 10);
            if (isNaN(n) || n < 1) n = 1;
            if (formQuantityInput) formQuantityInput.value = n;
            if (blockQtyInput) blockQtyInput.value = n;
        }

        function getQuantity() {
            var v = formQuantityInput ? formQuantityInput.value : (blockQtyInput ? blockQtyInput.value : "1");
            var n = parseInt(v, 10);
            return isNaN(n) || n < 1 ? 1 : n;
        }

        if (subtractBtn) {
            subtractBtn.addEventListener("click", function () { setQuantity(getQuantity() - 1); });
        }
        if (addBtn) {
            addBtn.addEventListener("click", function () { setQuantity(getQuantity() + 1); });
        }
        if (blockQtyInput && blockQtyInput !== formQuantityInput) {
            blockQtyInput.addEventListener("change", function () { setQuantity(blockQtyInput.value); });
        }
        if (formQuantityInput && formQuantityInput !== blockQtyInput) {
            formQuantityInput.addEventListener("change", function () { setQuantity(formQuantityInput.value); });
        }

        // Add to Bag: handle click in capture phase so we run before form submit (prevents redirect), then AJAX add + line animation
        var submitBtn = form.querySelector("[data-add-to-cart], .product-form__cart-submit");
        if (submitBtn) {
            submitBtn.addEventListener("click", function (e) {
                if (submitBtn.disabled) {
                    e.preventDefault();
                    e.stopPropagation();
                    return;
                }
                e.preventDefault();
                e.stopPropagation();

                submitBtn.disabled = true;
                submitBtn.classList.add("loading");

                var body = new FormData(form);
                var addUrl = (window.theme && window.theme.routes && window.theme.routes.cart && window.theme.routes.cart.add) ? (window.theme.routes.cart.add + (window.theme.routes.cart.add.indexOf(".js") !== -1 ? "" : ".js")) : "/cart/add.js";
                fetch(addUrl, {
                    method: "POST",
                    body: body
                })
                    .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
                    .then(function (result) {
                        submitBtn.disabled = false;
                        submitBtn.classList.remove("loading");
                        if (result.ok) {
                            document.dispatchEvent(new CustomEvent("cart:updated", { detail: result.data || {} }));
                            var modal = document.querySelector("[data-quick-view-modal]");
                            if (modal) {
                                modal.classList.remove("is-visible", "active", "is-fixed");
                                modal.setAttribute("aria-hidden", "true");
                                document.body.removeAttribute("data-fluorescent-overlay-open");
                            }
                        } else {
                            var errEl = container.querySelector("[data-quantity-error]");
                            if (errEl && result.data && result.data.description) {
                                errEl.textContent = result.data.description;
                                errEl.classList.remove("hidden");
                            }
                        }
                    })
                    .catch(function () {
                        submitBtn.disabled = false;
                        submitBtn.classList.remove("loading");
                    });
            }, true);
        }

        // Block form submit so it never redirects (backup in case click is not used)
        form.addEventListener("submit", function (e) {
            e.preventDefault();
            e.stopPropagation();
        }, true);
    }

    initProductPairingQuickView();
    initProductPairingQuickAdd();

        // Quick-view Add to Bag: document-level capture so we always intercept before form submit (no redirect), show line animation
        document.addEventListener("click", function (e) {
            var modal = document.querySelector("[data-quick-view-modal]");
            if (!modal || !modal.classList.contains("is-visible")) return;
            var content = modal.querySelector(".quick-view-modal__content");
            if (!content || content.classList.contains("empty")) return;

            var btn = e.target.closest("[data-add-to-cart], .product-form__cart-submit, button[type=submit][name=add]");
            if (!btn || !content.contains(btn)) return;

            var form = btn.form || btn.closest("form") || content.querySelector("[data-product-form]");
            if (!form || !content.contains(form)) return;

            e.preventDefault();
            e.stopPropagation();

            if (btn.disabled) return;

            btn.disabled = true;
            btn.classList.add("loading");

            var body = new FormData(form);
            var addUrl = (window.theme && window.theme.routes && window.theme.routes.cart && window.theme.routes.cart.add) ? (window.theme.routes.cart.add + (window.theme.routes.cart.add.indexOf(".js") !== -1 ? "" : ".js")) : "/cart/add.js";
            fetch(addUrl, {
                method: "POST",
                body: body
            })
                .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
                .then(function (result) {
                    btn.disabled = false;
                    btn.classList.remove("loading");
                    if (result.ok) {
                        document.dispatchEvent(new CustomEvent("cart:updated", { detail: result.data || {} }));
                        modal.classList.remove("is-visible", "active", "is-fixed");
                        modal.setAttribute("aria-hidden", "true");
                        document.body.removeAttribute("data-fluorescent-overlay-open");
                    } else {
                        var errEl = content.querySelector("[data-quantity-error]");
                        if (errEl && result.data && result.data.description) {
                            errEl.textContent = result.data.description;
                            errEl.classList.remove("hidden");
                        }
                    }
                })
                .catch(function () {
                    btn.disabled = false;
                    btn.classList.remove("loading");
                });
        }, true);

        // Block form submit in quick-view modal so it never redirects
        document.addEventListener("submit", function (e) {
            var modal = document.querySelector("[data-quick-view-modal]");
            if (!modal || !modal.classList.contains("is-visible")) return;
            var content = modal.querySelector(".quick-view-modal__content");
            if (!content || content.classList.contains("empty")) return;
            if (!content.contains(e.target)) return;
            e.preventDefault();
            e.stopPropagation();
        }, true);
    }

main()

